import { defineAsyncComponent } from 'vue';

const examineDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineDetail.vue'));
const requestSubmit = defineAsyncComponent(() => import('@/views/examine/popup/RequestSubmit.vue'));
const requestSubmitThreeYear = defineAsyncComponent(() => import('@/views/examine/popup/RequestSubmitThreeYear.vue'));
const createExamineForm = defineAsyncComponent(() => import('@/views/examine/popup/CreateExamineForm.vue'));
const createAuditEstimateInitialForm = defineAsyncComponent(() =>
  import('@/views/examine/initial/CreateAuditEstimateInitialForm.vue'),
);
const examineFormDetail = defineAsyncComponent(() => import('@/components/examine/ExamineFormDetail.vue'));
const examineFeedback = defineAsyncComponent(() => import('@/views/examine/popup/ExamineFeedback.vue'));
const examineComplete = defineAsyncComponent(() => import('@/views/examine/popup/ExamineComplete.vue'));
const examineFeedbackInitial = defineAsyncComponent(() => import('@/views/auditInitial/ExamineFeedbackInitial.vue'));
const examineCompleteInitial = defineAsyncComponent(() => import('@/views/auditInitial/ExamineCompleteInitial.vue'));
const examineDataUpdateAfterComplete = defineAsyncComponent(() => import('@/views/examine/popup/ExamineDataUpdateAfterComplete.vue'));
const examineThreeYearComplete = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineThreeYearComplete.vue'),
);
const examineArrgrateFeedback = defineAsyncComponent(() => import('@/views/examine/popup/ExamineArrgrateFeedback.vue'));
const examineArrgrateFeedbackThreeYear = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineArrgrateFeedbackThreeYear.vue'),
);
const examineArrgrateComplete = defineAsyncComponent(() => import('@/views/examine/popup/ExamineArrgrateComplete.vue'));
const examineDVCQFeedback = defineAsyncComponent(() => import('@/views/examine/popup/ExamineDVCQFeedback.vue'));
const examineDVCQComplete = defineAsyncComponent(() => import('@/views/examine/popup/ExamineDVCQComplete.vue'));
const examineRegularDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineRegularDetail.vue'));
const examineProjectDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineProjectDetail.vue'));
const examineInvestDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineInvestDetail.vue'));
const examineThreeDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineThreeYearDetail.vue'));
const summaryExamineThreeYearInvestDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryThreeYear/SummaryExamineThreeYearInvestDetail.vue'),
);

//SCQ kiểm tra đầu năm
const examineRegularInitialDetail = defineAsyncComponent(() => import('@/views/examine/popup/initial/ExamineRegularInitialDetail.vue'));
const examineProjectInitialDetail = defineAsyncComponent(() => import('@/views/examine/popup/initial/ExamineProjectInitialDetail.vue'));

const examineRevenueFeesInitialDetail = defineAsyncComponent(() => import('@/views/examine/popup/initial/ExamineRevenueFeesInitialDetail.vue'));

const examineRevenueBusinessInitialDetail = defineAsyncComponent(() => import('@/views/examine/popup/initial/ExamineRevenueBusinessInitialDetail.vue'));

// Màn detail chi đầu tư (tab dự toán kiểm tra) - nvthinh 18.09.2024
const examineThreeYearInvestDetail = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/ExamineThreeYearInvestDetail.vue'),
);
const examineThreeYearBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/ExamineThreeYearBusinessDetail.vue'),
);

const examineRevenueThreeYearBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/ExamineRevenueThreeYearBusinessDetail.vue'),
);
const examineThreeYearfeesDetail = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/ExamineThreeYearFeesDetail.vue'),
);
const examineThreeYearfeesDetailCheck = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/ExamineThreeYearFeesDetailCheck.vue'),
);
const examineRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineRevenueBusinessDetail.vue'),
);
const examineExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineExpenseBusinessDetail.vue'),
);

const examineRevenueFeeDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/fee/ExamineRevenueFeeDetail.vue'),
);
const examineExpenseFeeDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/fee/ExamineExpenseFeeDetail.vue'),
);
const examineExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineExpenseOtherDetail.vue'),
);

const examineRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineRevenueOtherDetail.vue'),
);

const examineBudgetDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineBudgetDetail.vue'));

const confirmDictionary = defineAsyncComponent(() => import('@/views/examine/popup/ConfirmDictionary.vue'));

const rejectDictionaryContent = defineAsyncComponent(() => import('@/views/examine/popup/RejectDictionaryContent.vue'));

const examineCalculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineCalculationBasisDetail.vue'),
);

const selectCombineContent = defineAsyncComponent(() => import('@/views/examine/popup/SelectCombineContent.vue'));

const examineChildDetail = defineAsyncComponent(() => import('@/views/examine/popup/ExamineChildDetail.vue'));
const examineDemandsProjectDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsProjectDetail.vue'),
);
const examineDemandsRegularDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsRegularDetail.vue'),
);
const examineDemandsInvestDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsInvestDetail.vue'),
);
const examineDemandsOtherDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsOtherDetail.vue'),
);
const examineDemandsBudgetDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsBudgetDetail.vue'),
);
const ExamineDemandsRevenueExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsRevenueExpenseFeesDetail.vue'),
);
const ExamineDemandsEstimateExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsEstimateExpenseBusinessDetail.vue'),
);
const ExamineDemandsEstimateRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/demands/ExamineDemandsEstimateRevenueBusinessDetail.vue'),
);

const dictionaryApproveMerge = defineAsyncComponent(() =>
  import('@/views/examine/dictionary/DictionaryApproveMerge.vue'),
);
const dictionaryBudgetContentPopup = defineAsyncComponent(() =>
  import('@/views/examine/dictionary/DictionaryBudgetContentPopup.vue'),
);

const chooseOrgBudgetYearPopup = defineAsyncComponent(() =>
  import('@/views/examine/popup/ChooseOrgBudgetYearPopup.vue'),
);

const confirmDeleteExamineForm = defineAsyncComponent(() =>
  import('@/views/examine/popup/ConfirmDeleteExamineForm.vue'),
);
const notificationRequestSubmitEstimatePopup = defineAsyncComponent(() =>
  import('@/views/examine/popup/NotificationRequestSubmitEstimatePopup.vue'),
);

const ExamineArrgrateRegularDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateRegularDetail.vue'),
);

const ExamineArrgrateInvestDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateInvestDetail.vue'),
);
const ExamineArrgrateExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateExpenseBusinessDetail.vue'),
);

const ExamineArrgrateRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateRevenueBusinessDetail.vue'),
);

const ExamineArrgrateExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateExpenseFeesDetail.vue'),
);

const ExamineArrgrateProjectDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateProjectDetail.vue'),
);

const examineArrgrateCalculationBasisDetailOrg = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineArrgrateCalculationBasisDetailOrg.vue'),
);

const examineArrgrateCalculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineArrgrateCalculationBasisDetail.vue'),
);

const examineCalculationBasisDetailPTC = defineAsyncComponent(() =>
  import('@/views/examine/popup/ptc/ExamineCalculationBasisDetailPTC.vue'),
);

const ExamineArrgrateCalculationDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateCalculationDetail.vue'),
);

const ExamineArrgrateExplanationRegularPopup = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateExplanationRegularPopup.vue'),
);
const auditReceiveArrgrateExplanationSalaryPopup = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/popup/AuditReceiveArrgrateExplanationSalaryPopup.vue'),
);

const ExamineArrgrateRevenueFeesDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateRevenueFeesDetail.vue'),
);
const auditArrgrateProject = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateProject.vue'));
const auditArrgrateProjectOrg = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateProjectOrg.vue'));
const auditArrgrateProjectSTC = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateProjectSTC.vue'));

const auditArrgrateRegular = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateRegular.vue'));
const auditArrgrateInvest = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateInvest.vue'));
const auditArrgrateRegularOrg = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateRegularOrg.vue'));

const examineRevenueFeeDetailCqsn = defineAsyncComponent(() =>
  import('@/views/examine/popup/cqsn/ExamineRevenueFeeDetailCqsn.vue'),
);

const examineExpenseFeeDetailCqsn = defineAsyncComponent(() =>
  import('@/views/examine/popup/cqsn/ExamineExpenseFeeDetailCqsn.vue'),
);
const examineRevenueBusinessDetailCqsn = defineAsyncComponent(() =>
  import('@/views/examine/popup/cqsn/ExamineRevenueBusinessDetailCqsn.vue'),
);

const AuditArrgrateExplanationSalaryPopup = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/popup/AuditArrgrateExplanationSalaryPopup.vue'),
);

const ReturnArrgrateExplanationSalaryPopup = defineAsyncComponent(() =>
  import('@/views/returnArrgrate/ReturnArrgrateExplanationSalaryPopup.vue'),
);
const examineExpenseBusinessDetailCqsn = defineAsyncComponent(() =>
  import('@/views/examine/popup/cqsn/ExamineExpenseBusinessDetailCqsn.vue'),
);

const examineReceiveArrgrateExpenseOtherStc = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineReceiveArrgrateExpenseOther.vue'),
);

const ExamineArrgrateRevenueBudgetDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateRevenueBudgetDetail.vue'),
);

const AuditReceiveArrgrateBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/AuditReceiveArrgrateBudgetDetailAgency.vue'),
);

const ExamineEstArrgrateExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineEstArrgrateExpenseOtherDetail.vue'),
);

const ExamineArrgrateRevenueOtherDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/arrgrate/ExamineArrgrateRevenueOtherDetail.vue'),
);
const auditArrgrateInvestDetailSTC = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/AuditArrgrateInvestDetailSTC.vue'),
);
const auditArrgrateInvestCapitalDetailSTC = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/AuditArrgrateInvestCapitalDetailSTC.vue'),
);

const auditArrgrateBudgetCollection = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/AuditArrgrateBudgetCollection.vue'),
);
const auditArrgrateBudgetCollectionOrg = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/AuditArrgrateBudgetCollectionOrg.vue'),
);
const auditArrgrateBudgetDetailAgency = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/popup/AuditArrgrateBudgetDetailAgency.vue'),
);

const ArrgrateExplanationSalaryViewPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/ArrgrateExplanationSalaryViewPopup.vue'),
);

const auditArrgrateRegularSTC = defineAsyncComponent(() => import('@/views/auditArrgrate/AuditArrgrateRegularSTC.vue'));

const examineRevenueOtherDetailPTC = defineAsyncComponent(() =>
  import('@/views/examine/popup/ExamineRevenueOtherDetailPTC.vue'),
);
const createExamineThreeYearForm = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/CreateExamineThreeYearForm.vue'),
);

const estimateArrgrateSalaryPopup = defineAsyncComponent(() =>
  import('@/views/auditArrgrate/popup/AuditEstArrgrateSalaryAttachmentPopup.vue'),
);
// AuditEstimateArrgrateThreeYearBusinessDetail

const auditEstimateArrgrateThreeYearBusinessDetail = defineAsyncComponent(() =>
  import('@/views/examine/tabThreeYear/EstimateArrgrate/AuditEstimateArrgrateThreeYearBusinessDetailPTC.vue'),
);
const BusinessTYAuditReceiveArrgrateDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/BusinessTYAuditReceiveArrgrateDetail.vue'),
);

const requestSubmitInitial = defineAsyncComponent(() => import('@/views/examine/popup/RequestSubmitInitial.vue'));

const ArrgrateExplanationSalaryViewSTCPopup = defineAsyncComponent(() =>
  import('@/views/submit/popup/ArrgrateExplanationSalaryViewSTCPopup.vue'),
);

const ExamineExpenseBusinessInitialDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/initial/ExamineExpenseBusinessInitialDetail.vue'),
);

const ExamineExpenseFeesInitialDetail = defineAsyncComponent(() =>
  import('@/views/examine/popup/initial/ExamineExpenseFeesInitialDetail.vue'),
);

const examineDetailInitial = defineAsyncComponent(() => import('@/views/examine/popup/ExamineDetailInitial.vue'));
const confirmDictionaryInitial = defineAsyncComponent(() => import('@/views/examine/popup/ConfirmDictionaryInitial.vue'));
const dictionaryApproveMergeInitial = defineAsyncComponent(() => import('@/views/examine/dictionaryInitial/DictionaryApproveMergeInitial.vue'));

export function registerExamine(app) {
  app.component('ExamineCalculationBasisDetail', examineCalculationBasisDetail);
  app.component('ExamineEstArrgrateExpenseOtherDetail', ExamineEstArrgrateExpenseOtherDetail);
  app.component('ExamineDetail', examineDetail);
  app.component('ExamineThreeDetail', examineThreeDetail);
  app.component('ExamineRegularDetail', examineRegularDetail);
  app.component('ExamineRegularInitialDetail', examineRegularInitialDetail);
  app.component('ExamineRevenueFeesInitialDetail', examineRevenueFeesInitialDetail);
  app.component('ExamineRevenueBusinessInitialDetail', examineRevenueBusinessInitialDetail);
  app.component('ExamineProjectInitialDetail', examineProjectInitialDetail);
  app.component('ExamineProjectDetail', examineProjectDetail);
  app.component('ExamineInvestDetail', examineInvestDetail);
  app.component('ExamineRevenueBusinessDetail', examineRevenueBusinessDetail);
  app.component('ExamineExpenseBusinessDetail', examineExpenseBusinessDetail);
  app.component('ExamineRevenueFeeDetail', examineRevenueFeeDetail);
  app.component('ExamineExpenseFeeDetail', examineExpenseFeeDetail);
  app.component('ExamineExpenseOtherDetail', examineExpenseOtherDetail);
  app.component('ExamineRevenueOtherDetail', examineRevenueOtherDetail);
  app.component('ExamineBudgetDetail', examineBudgetDetail);
  app.component('RequestSubmit', requestSubmit);
  app.component('RequestSubmitThreeYear', requestSubmitThreeYear);
  app.component('CreateExamineForm', createExamineForm);
  app.component('CreateAuditEstimateInitialForm', createAuditEstimateInitialForm);
  app.component('ExamineFormDetail', examineFormDetail);
  app.component('ExamineFeedback', examineFeedback);
  app.component('ConfirmDictionary', confirmDictionary);
  app.component('RejectDictionaryContent', rejectDictionaryContent);
  app.component('SelectCombineContent', selectCombineContent);
  app.component('ExamineChildDetail', examineChildDetail);
  app.component('ExamineDemandsProjectDetail', examineDemandsProjectDetail);
  app.component('ExamineDemandsRegularDetail', examineDemandsRegularDetail);
  app.component('AuditReceiveArrgrateExplanationSalaryPopup', auditReceiveArrgrateExplanationSalaryPopup);
  app.component('ExamineDemandsInvestDetail', examineDemandsInvestDetail);
  app.component('ExamineDemandsOtherDetail', examineDemandsOtherDetail);
  app.component('ExamineDemandsBudgetDetail', examineDemandsBudgetDetail);
  app.component('ExamineArrgrateCalculationBasisDetailOrg', examineArrgrateCalculationBasisDetailOrg);
  app.component('ExamineArrgrateCalculationBasisDetail', examineArrgrateCalculationBasisDetail);
  app.component('ExamineDemandsRevenueExpenseFeesDetail', ExamineDemandsRevenueExpenseFeesDetail);
  app.component('ExamineDemandsEstimateExpenseBusinessDetail', ExamineDemandsEstimateExpenseBusinessDetail);
  app.component('ExamineDemandsEstimateRevenueBusinessDetail', ExamineDemandsEstimateRevenueBusinessDetail);
  app.component('DictionaryApproveMerge', dictionaryApproveMerge);
  app.component('DictionaryBudgetContentPopup', dictionaryBudgetContentPopup);
  app.component('ChooseOrgBudgetYearPopup', chooseOrgBudgetYearPopup);
  app.component('ConfirmDeleteExamineForm', confirmDeleteExamineForm);
  app.component('ExamineComplete', examineComplete);
  app.component('ExamineDataUpdateAfterComplete', examineDataUpdateAfterComplete);
  app.component('ExamineThreeYearComplete', examineThreeYearComplete);
  app.component('NotificationRequestSubmitEstimatePopup', notificationRequestSubmitEstimatePopup);
  app.component('ExamineArrgrateRegularDetail', ExamineArrgrateRegularDetail);
  app.component('ExamineArrgrateInvestDetail', ExamineArrgrateInvestDetail);
  app.component('ExamineArrgrateExpenseBusinessDetail', ExamineArrgrateExpenseBusinessDetail);
  app.component('ExamineArrgrateRevenueBusinessDetail', ExamineArrgrateRevenueBusinessDetail);
  app.component('ExamineArrgrateProjectDetail', ExamineArrgrateProjectDetail);
  app.component('ExamineArrgrateCalculationDetail', ExamineArrgrateCalculationDetail);
  app.component('ExamineArrgrateExplanationRegularPopup', ExamineArrgrateExplanationRegularPopup);
  app.component('ExamineArrgrateExpenseFeesDetail', ExamineArrgrateExpenseFeesDetail);
  app.component('ExamineArrgrateRevenueFeesDetail', ExamineArrgrateRevenueFeesDetail);
  app.component('AuditArrgrateProject', auditArrgrateProject);
  app.component('AuditArrgrateProjectOrg', auditArrgrateProjectOrg);
  app.component('AuditArrgrateProjectSTC', auditArrgrateProjectSTC);
  app.component('AuditArrgrateRegular', auditArrgrateRegular);
  app.component('AuditArrgrateRegularOrg', auditArrgrateRegularOrg);
  app.component('AuditArrgrateInvest', auditArrgrateInvest);
  app.component('AuditArrgrateBudgetCollection', auditArrgrateBudgetCollection);
  app.component('AuditArrgrateBudgetCollectionOrg', auditArrgrateBudgetCollectionOrg);
  app.component('ExamineArrgrateComplete', examineArrgrateComplete);
  app.component('ExamineArrgrateFeedback', examineArrgrateFeedback);
  app.component('ExamineArrgrateFeedbackThreeYear', examineArrgrateFeedbackThreeYear);
  app.component('ExamineDVCQComplete', examineDVCQComplete);
  app.component('ExamineDVCQFeedback', examineDVCQFeedback);
  app.component('ExamineRevenueFeeDetailCqsn', examineRevenueFeeDetailCqsn);
  app.component('ExamineExpenseFeeDetailCqsn', examineExpenseFeeDetailCqsn);
  app.component('ExamineRevenueBusinessDetailCqsn', examineRevenueBusinessDetailCqsn);
  app.component('ReturnArrgrateExplanationSalaryPopup', ReturnArrgrateExplanationSalaryPopup);
  app.component('AuditArrgrateExplanationSalaryPopup', AuditArrgrateExplanationSalaryPopup);
  app.component('ExamineExpenseBusinessDetailCqsn', examineExpenseBusinessDetailCqsn);
  app.component('ExamineArrgrateRevenueBudgetDetail', ExamineArrgrateRevenueBudgetDetail);
  app.component('AuditReceiveArrgrateBudgetDetailAgency', AuditReceiveArrgrateBudgetDetailAgency);
  app.component('ExamineArrgrateRevenueOtherDetail', ExamineArrgrateRevenueOtherDetail);
  app.component('ExamineReceiveArrgrateExpenseOtherStc', examineReceiveArrgrateExpenseOtherStc);
  app.component('ExamineThreeYearBusinessDetail', examineThreeYearBusinessDetail);
  app.component('ExamineThreeYearfeesDetail', examineThreeYearfeesDetail);
  app.component('ExamineExpenseBusinessInitialDetail', ExamineExpenseBusinessInitialDetail);
  app.component('ExamineExpenseFeesInitialDetail', ExamineExpenseFeesInitialDetail);
  app.component('ExamineThreeYearfeesDetailCheck', examineThreeYearfeesDetailCheck);
  app.component('ExamineCalculationBasisDetailPTC', examineCalculationBasisDetailPTC);
  app.component('AuditArrgrateInvestDetailSTC', auditArrgrateInvestDetailSTC);
  app.component('AuditArrgrateInvestCapitalDetailSTC', auditArrgrateInvestCapitalDetailSTC);
  app.component('AuditArrgrateRegularSTC', auditArrgrateRegularSTC);
  app.component('ExamineRevenueOtherDetailPTC', examineRevenueOtherDetailPTC);
  app.component('AuditArrgrateBudgetDetailAgency', auditArrgrateBudgetDetailAgency);
  app.component('ExamineRevenueThreeYearBusinessDetail', examineRevenueThreeYearBusinessDetail);
  app.component('ArrgrateExplanationSalaryViewPopup', ArrgrateExplanationSalaryViewPopup);
  app.component('CreateExamineThreeYearForm', createExamineThreeYearForm);
  app.component('ExamineThreeYearInvestDetail', examineThreeYearInvestDetail);
  app.component('SummaryExamineThreeYearInvestDetail', summaryExamineThreeYearInvestDetail);
  app.component('AuditEstArrgrateSalaryAttachmentPopup', estimateArrgrateSalaryPopup);
  app.component('AuditEstimateArrgrateThreeYearBusinessDetailSTC', auditEstimateArrgrateThreeYearBusinessDetail);
  app.component('BusinessTYAuditReceiveArrgrateDetail', BusinessTYAuditReceiveArrgrateDetail);
  app.component('RequestSubmitInitial', requestSubmitInitial);
  app.component('ArrgrateExplanationSalaryViewSTCPopup', ArrgrateExplanationSalaryViewSTCPopup);
  app.component('ExamineDetailInitial', examineDetailInitial);
  app.component('ExamineFeedbackInitial', examineFeedbackInitial);
  app.component('ExamineCompleteInitial', examineCompleteInitial);
  app.component('ConfirmDictionaryInitial', confirmDictionaryInitial);
  app.component('DictionaryApproveMergeInitial', dictionaryApproveMergeInitial);
}
